import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicLayout from "../../../layauots/BasicLayout";
import { Card, Alert, AlertTitle, Checkbox, FormControlLabel } from "@mui/material";
import MDBox from "../../../controls/MDBox";
import MDTypography from "../../../controls/MDTypography";
import MDInput from "../../../controls/MDInput";
import MDButton from "../../../controls/MDButton";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import bgImage from "../../../../assets/images/bg-sign-up-cover.jpeg";
import * as yup from "yup";
import { postData } from "../../../Utils/Http/api";

const SujetoContactoPrioridadAdd = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    descripcion: "",
    activo: true,
    orden: "-1"
  });

  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);
  const [grabando, setGrabando] = useState(false);
  const [nombreboton, setnombreboton] = useState("Cancelar");

  const validationSchema = yup.object().shape({
    descripcion: yup.string().required("El campo Descripción es obligatorio"),
  });

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleVolver = () => {
    navigate("/SujetoContactoPrioridadList");
  };

  const handleSubmit = async () => {
    try {
      await validationSchema.validate(formData);
      setGrabando(true);
      setnombreboton("Volver");
      setMensaje("");
      setExito(false);

      const payload = { ...formData, activo: formData.activo ? 1 : 0 };
      const res = await postData("/SujetoPrioridadContactoAlta", payload);

      if (res?.isSuccess) {
        setMensaje("¡Prioridad de Contacto agregada exitosamente!");
        setExito(true);
      } else {
        setMensaje(res?.error || "Error al guardar");
        setExito(false);
        setGrabando(false);
      }
    } catch (error) {
      setMensaje(error.message || "Error de validación");
      setExito(false);
      setGrabando(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card style={{ width: "157%" }}>
        <MDBox
          variant="gradient"
          bgColor="secondary"
          borderRadius="lg"
          coloredShadow="light"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Agregar Prioridad de Contacto
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Permite definir prioridades de contacto asociadas a los sujetos.
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="descripcion"
                label="Descripción"
                variant="standard"
                value={formData.descripcion}
                onChange={handleInputChange}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <FormControlLabel
                control={<Checkbox name="activo" checked={!!formData.activo} onChange={handleInputChange} />}
                label="Activo"
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="number"
                name="orden"
                label="Orden"
                variant="standard"
                value={formData.orden}
                onChange={handleInputChange}
                fullWidth
              />
            </MDBox>
            <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
              <MDButton
                onClick={handleSubmit}
                variant="gradient"
                color="success"
                endIcon={<Save />}
                disabled={grabando}
                fullWidth
              >
                Grabar
              </MDButton>

              <MDButton
                onClick={handleVolver}
                variant="gradient"
                color="error"
                endIcon={<ExitToApp />}
                fullWidth
              >
                {nombreboton}
              </MDButton>
            </MDBox>
          </MDBox>

          {mensaje && (
            <Alert severity={exito ? "success" : "error"}>
              <AlertTitle>{exito ? "Felicitaciones" : "Error"}</AlertTitle>
              {mensaje}
            </Alert>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default SujetoContactoPrioridadAdd;
